import { Dialog } from '@mui/material';
import Plan from 'layouts/profile/components/Subscription/plan';

const RequireActiveSubscription = ({ hasActiveSubscription, loading, initialLoadComplete, children }) => {
    // 1. Loading state
    if ((loading || hasActiveSubscription === null) && !initialLoadComplete) {
        return null;
    }

    // [NEW] Background Re-validation Stabilization
    if (loading && initialLoadComplete) {
        return children;
    }

    // 2. Restriction Check
    if (hasActiveSubscription === false) {
        // Render the Plan Dialog if the check fails
        return (
            <Dialog
                open={true}
                onClose={() => { }} // Block closing
                maxWidth="xl"
                fullWidth
                scroll="body"
                disableEscapeKeyDown
                PaperProps={{
                    sx: { position: "relative" }
                }}
            >
                <Plan
                    onSubscriptionUpdate={() => console.log("Purchase complete, refresh data...")}
                    onClose={() => { }} // Block closing the inner component
                    canClose={false}
                />
            </Dialog>
        );
    }

    // 3. Pass through
    return children;
};

export default RequireActiveSubscription;